// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1b1ee538","749":"0eb1ebc6","754":"138692d0"}[chunkId] + ".chunk.js";
};